import * as actions from './cash-flow.actions';
import { CashFlow, CashFlowFilter, Periods } from './cash-flow.models';
import { DatesInterval } from '../../global/interfaces';
import { SortInfo } from '../../global/interfaces';

export interface State {
  loading: boolean;
  dates?: DatesInterval;
  data: CashFlow[];
  filter: CashFlowFilter;
  sort: SortInfo;

}

export const initialState: State = {
  loading: false,
  dates: undefined,
  data: [],
  filter: {
    period: Periods.MONTH,
    year: undefined,
    month: undefined,
    quarter: undefined
  },
  sort: {
    column: 'date',
    reverse: true
  },
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ActionTypes.LOAD_CASH_DATES:
      return { ...state, loading: true,
        dates: undefined,
        filter: { ...initialState.filter }
      };
    case actions.ActionTypes.LOAD_CASH_DATES_SUCCESS:
      return { ...state, loading: false, dates: action.payload };
    case actions.ActionTypes.LOAD_CASH_DATES_FAILED:
      return { ...state, loading: false };

    case actions.ActionTypes.LOAD_CASH_DATA:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_CASH_DATA_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case actions.ActionTypes.LOAD_CASH_DATA_FAILED:
      return { ...state, loading: false };

    case actions.ActionTypes.SET_CASH_FLOW_PERIOD_FILTER:
      return { ...state, filter: { ...state.filter, period: action.payload } };
    case actions.ActionTypes.SET_CASH_FLOW_YEAR_FILTER:
      return { ...state, filter: { ...state.filter, year: action.payload } };
    case actions.ActionTypes.SET_CASH_FLOW_MONTH_FILTER:
      return { ...state, filter: { ...state.filter, month: action.payload } };
    case actions.ActionTypes.SET_CASH_FLOW_QUARTER_FILTER:
      return { ...state, filter: { ...state.filter, quarter: action.payload } };
      case actions.ActionTypes.SET_CASH_FLOW_SORT:
        return { ...state, sort: action.payload };

    case actions.ActionTypes.RESET_CASH_FLOW_DATA:
      return initialState;
      case actions.ActionTypes.RESET_CASH_FLOW_DATA_RECORDS:
        return { ...state, data: initialState.data };

    default:
      return state;
  }
}
